import {DataType, ApiClients} from '@salesforce/commerce-sdk-react/hooks/types'
type ClientProduct = ApiClients['shopperProducts']

export type ProductType = DataType<ClientProduct['getProduct']>

export enum ProductListingVisualization {
    PRODUCTS = 0,
    STORIES = 1,
}

export interface ProductImpression {
    name: string
    id: string
    price: string
    category: string
    callout?: string
    variant: string
    tileType: string
    color: string
    gender: string
    list: string
    position?: string
    quantity?: number
    dimension14?: string
    dimension21?: string
    dimension22?: string
    dimension26?: string
    dimension27?: string
}
